import script from "./NavTree.vue?vue&type=script&setup=true&lang=js"
export * from "./NavTree.vue?vue&type=script&setup=true&lang=js"

import "./NavTree.vue?vue&type=style&index=0&id=2c545662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c545662"]])

export default __exports__